import { environment } from "src/environments/environment";
import { Microfrontend } from "../core/models/types/microfrontend.types";
import { RemoteMenuType } from "../core/models/enums/remote-menu.enum";
import { TecComModuleType, TranslationScopeType } from "shared-states";
import { anonymousOnlyGuard } from "../core/navigation/guards/anonymous-only.guard";

export const PUBLIC_REMOTES_ROUTES: Microfrontend[] = [
  {
    ...environment.microfrontends.returns,
    exposedModule: environment.microfrontends.returns.exposedModule[1],
    displayName: 'ReturnsPublic',
    displayLabel: false,
    routePath: 'returns-public',
    ngModuleName: 'ReturnsPublicModule',
    menuType: RemoteMenuType.None,
    i18nPath: 'assets/returns/i18n/'
  },
  {
    ...environment.microfrontends.registration,
    exposedModule: environment.microfrontends.registration.exposedModule[0],
    displayName: 'Registration',
    displayLabel: false,
    routePath: 'registration',
    ngModuleName: 'RegistrationRemoteModule',
    menuType: RemoteMenuType.None,
    isBeta: true,
    module: TecComModuleType.registration,
    translationScope: TranslationScopeType.registration,
    hidePublicHeader: true,
    // Registration is for anonymous users only; logged-in users are redirected.
    // TODO: clarify behavior for invitation links and email confirmation pages
    // opened in a browser that already has an Okta session.
    canActivate: [anonymousOnlyGuard]
  }
]
